<template>
    <router-link :to="toRoute" :class="[type, {active_ev : !getCurrentProvider}]" :key="renderKey">
        <!-- Provider's Title -->
        <div :class="['title', {active_prov : !currEvent && getCurrentProvider === selProvider && $route.path.includes(day)}]">
            <i 
                :class="['el-icon-arrow-right location-expand-icon', { open: (hasLocation ? openLocationList : openEventOnlyList) }]" 
                @click="() => { this.hasLocation ? this.expandLocationList() : this.expandEventOnlyList() }">
            </i>
            <!-- Slot for title of the provider expand -->
            <span :class="{ zero : totalCount == 0 }">{{ totalCount }}</span>
            <slot></slot>
        </div>
        <!-- Location List and event list -->
        <div v-if="hasLocation" name="location-expand">
            <div class="location-list" v-if="openLocationList">
                <div v-for="(locationObj, index) in locationWisePatients"
                    :key="day+'-'+selProvider+'-'+locationObj.location"
                    :class="['location-cont']"
                    @click.stop.prevent="setProviderLocation(selProvider, locationObj.location)">
                    <div :class="[$route.path.includes(day) && $route.path.includes(locationObj.location) && getCurrentProvider === selProvider ? 'location-active' : '']">
                        <i :class="['el-icon-arrow-right event-expand-icon', { open: openEventList[index] }]" @click="expandEventList(index)"></i>
                        <el-tooltip :disabled="locationObj.location && locationObj.location.length < 15" 
                                    :content="locationObj.location" placement="right" effect="dark" :open-delay="100">
                            <span class="location-name">
                                {{ getSlicedName(locationObj.location) }}
                            </span>
                        </el-tooltip>
                        
                        <span class="location-patients">{{ getLocationCount(locationObj) }}</span>
                    </div>

                    <!-- Provider's Event List -->
                    <div class="event-list" v-if="openEventList[index]">
                        <span v-for="(scheduleEventObj) in locationObj.events"
                            :key="day+'-'+selProvider+'-'+scheduleEventObj.eventId"
                            :class="['event-cont', { active_event : $route.path.includes(day) && $route.path.includes(locationObj.location) && getCurrentProvider === selProvider && $route.path.includes(scheduleEventObj.eventId)}]"
                            @click.stop.prevent="setProviderEvent(selProvider, scheduleEventObj.eventId, locationObj.location)">
                            <el-tooltip :disabled="scheduleEventObj['eventName'].length < 15" :content="scheduleEventObj.eventName" placement="right" effect="dark" :open-delay="100">
                                <span class="event-name">
                                    {{ getSlicedName(scheduleEventObj.eventName) }}
                                </span>
                            </el-tooltip>
                            
                            <span class="event-patients">{{ scheduleEventObj.currSchedObj.length }}</span>
                        </span>
                    </div>
                    <!-- Shows selected event even when the event list is closed -->
                    <!-- <div class="event-list" :style="{ maxHeight : 28 + 'px'}" v-if="showEventOnClose(index) && getCurrentSelectedEvent">
                        <span :key="day+'-'+selProvider+'-'+currEvent"
                            :class="['event-cont', {active_event : $route.path.includes(day) && getCurrentProvider === selProvider && $route.path.includes(currEvent)}]"
                            @click.stop.prevent="setProviderEvent(selProvider, currEvent)">
                            <el-tooltip :disabled="getCurrentSelectedEvent.events[0]['eventName'].length < 15" :content="getCurrentSelectedEvent.events[0].eventName" placement="bottom" effect="dark" :open-delay="1000">
                                <span class="event-name">
                                    {{ getSlicedName(getCurrentSelectedEvent.events[0].eventName) }}
                                </span>
                            </el-tooltip>
                            
                            <span class="event-patients">{{ getCurrentSelectedEvent.events[0].currSchedObj.length }}</span>
                        </span>
                    </div> -->

                </div>
            </div>
        </div>
        <!-- Only event list -->
        <div v-else name="event-expand">
            <div class="event-list" v-if="openEventOnlyList">
                <div v-for="(scheduleEventObj) in eventWisePatients"
                    :key="day+'-'+selProvider+'-'+scheduleEventObj.eventId"
                    :class="['event-cont', {active_event : $route.path.includes(day) && getCurrentProvider === selProvider && $route.path.includes(scheduleEventObj.eventId)}]"
                    @click.stop.prevent="setProviderEvent(selProvider, scheduleEventObj.eventId)">
                    <el-tooltip :disabled="scheduleEventObj['eventName'].length < 18" :content="scheduleEventObj.eventName" placement="bottom" effect="dark" :open-delay="1000">
                        <span class="event-name">
                            {{ getSlicedName(scheduleEventObj.eventName, 'event') }}
                        </span>
                    </el-tooltip>
                    
                    <span class="only-event-patients">{{ scheduleEventObj.currSchedObj.length }}</span>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import provider from '@/store/module/provider'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import SidebarList from '.'


/**
 * Expanding component to give a list of
 * providers to be reused for expanding and contracting
 * provider list for different components of the sidebar
 */
export default {
    name: 'event-expand',
    extends: SidebarList,

    props: {
        eventwisePatientCountForDuration: {
            type: Array,
            required: true,
            default: () => []
        },
        totalCount: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'event'
        },
        toRoute: {
            type: String,
            // default: '/patient'
        },
        selProvider: {
            type: String,
            // default: 0
        },
        currEvent: {
            type: String,
            default: null
        },
        day: {
            default: String
        }
    },

    data() {
        return {
            // toRoute: '',
            renderKey: 0,
            openLocationList: false,
            openEventOnlyList: false,
            openEventList: Array(20).fill(false)
        }
    },

    methods: {
        ...mapActions('provider', [
            'setCurrentProvider',
        ]),
        getLocationCount(locationObj) {
            let count = 0
            locationObj.events.forEach(eventObj => {
                count += eventObj.currSchedObj.length
            })
            return count
        },
        // showEventOnClose(locIndex) {
        //     return this.currEvent && !this.openEventList[locIndex] && this.$route.path.includes(this.toRoute)
        // },
        expandLocationList() {
            this.openLocationList = !this.openLocationList
        },
        expandEventList(locIndex) {
            this.openEventList[locIndex] = !this.openEventList[locIndex]
            this.renderKey += 1
        },
        expandEventOnlyList() {
            this.openEventOnlyList = !this.openEventOnlyList
            this.renderKey += 1
        },
        setProviderLocation(provider, location) {
            this.setCurrentProvider(provider)
            this.$router.push({ path: '/upcoming/' + this.day + '/' + location}).catch(()=>{})
            this.expandEventList()
        },
        setProviderEvent(provider, currEvnt, location) {
            this.$emit('set-curr-event', currEvnt)
            this.setCurrentProvider(provider)
            this.$router.push({ path: '/upcoming/' + this.day + '/' + location + '/' + currEvnt}).catch(()=>{})
        },
        getSlicedName(name, nameType) {
            let limit = 14
            if (nameType && nameType === 'event') {
                limit = 18
            }
            const sliced = name.slice(0, limit)
            if(name.length > limit)
                return sliced + '...'
            return sliced
        },
        getEventName(eventId) {
            return this.getContentKey('event', eventId, 'name')
        }
    },

    computed: {
        ...mapState('provider', [
            'overview'
        ]),
        ...mapGetters("content", ["getContentKey"]),
        ...mapGetters('provider', [
            'getCurrentProvider',
            'getProvider',
            'getProviderPatientList'
        ]),
        ...mapGetters(['getUserType']),
        /**
         * Checks if the provider has location
         * (Only integration providers can have location)
         */
        hasLocation() {
            let hasLocation = false
            let upcomingMappedSchedule = this.overview && this.overview.schedule_map
            if (this.eventwisePatientCountForDuration.length > 0) {
                this.eventwisePatientCountForDuration.forEach(curr => {
                    let eventObj = upcomingMappedSchedule[curr]
                    if (eventObj && eventObj.location !== undefined) {
                        hasLocation = true
                    }
                })
            }
            return hasLocation
        },
        eventWisePatients() {
            let upcomingMappedSchedule = this.overview && this.overview.schedule_map
            if(this.eventwisePatientCountForDuration.length > 0) {
                let temp = this.eventwisePatientCountForDuration.reduce((acc, curr) => {
                    let currSchedObj = upcomingMappedSchedule[curr]
                    let eventName = this.getEventName(currSchedObj.event) || currSchedObj.event
                    let eventFnd =  acc.find(evntObj => 
                        evntObj.eventId === currSchedObj.event
                    )
                    if(eventFnd !== undefined) {
                        acc.map(evnObj => {
                            if(evnObj.eventId === currSchedObj.event) {
                                evnObj['currSchedObj'].push(currSchedObj)
                                return evnObj
                            } else {
                                return evnObj
                            }
                        })
                    }
                    else {
                        acc.push({
                            'eventId': currSchedObj.event,
                            'eventName': eventName,
                            'currSchedObj': [currSchedObj]
                        })
                    }
                    return acc
                }, []).sort((a,b) => 
                            (a.eventName.toUpperCase() > b.eventName.toUpperCase()) ? 1 : ((b.eventName.toUpperCase() > a.eventName.toUpperCase()) ? -1 : 0)
                        )
                return temp
            } else return []
        },
        locationWisePatients() {
            let upcomingMappedSchedule = this.overview && this.overview.schedule_map
            if (this.eventwisePatientCountForDuration.length > 0) {
                let locationWiseEvents = this.eventwisePatientCountForDuration.reduce((acc, curr) => {
                    let eventObj = upcomingMappedSchedule[curr]
                    // reduces on the basis of location key in eventObj
                    // and returns an array of objects with location as key
                    // and array of event ids as value
                    let location = eventObj.location
                    if (location === undefined) {
                        location = 'Other'
                    }
                    let locationFnd = acc.find(locObj => 
                        locObj.location === location
                    )

                    if (locationFnd !== undefined) {
                        acc.map(locObj => {
                            if(locObj.location === location) {
                                locObj.events.push(curr)
                                return locObj
                            } else {
                                return locObj
                            }
                        })
                    }
                    else {
                        acc.push({
                            'location': location,
                            events: [curr]
                        })
                    }
                    return acc
                }, [])
                locationWiseEvents.forEach(loc => {
                    loc.events = loc.events.reduce((acc, curr) => {
                        let currSchedObj = upcomingMappedSchedule[curr]
                        let eventName = this.getEventName(currSchedObj.event) || currSchedObj.event
                        let eventFnd =  acc.find(evntObj => 
                            evntObj.eventId === currSchedObj.event
                        )
                        if(eventFnd !== undefined) {
                            acc.map(evnObj => {
                                if(evnObj.eventId === currSchedObj.event) {
                                    evnObj['currSchedObj'].push(currSchedObj)
                                    return evnObj
                                } else {
                                    return evnObj
                                }
                            })
                        }
                        else {
                            acc.push({
                                'eventId': currSchedObj.event,
                                'eventName': eventName,
                                'currSchedObj': [currSchedObj]
                            })
                        }
                        return acc
                    }, []).sort((a,b) => 
                        (a.eventName.toUpperCase() > b.eventName.toUpperCase()) ? 1 : ((b.eventName.toUpperCase() > a.eventName.toUpperCase()) ? -1 : 0)
                    )
                })
                // locationwiseevents.location is 'Other' then it is pushed to the end of the array
                locationWiseEvents.sort((a,b) => 
                    (a.location.toUpperCase() === 'OTHER') ? 1 : ((b.location.toUpperCase() === 'OTHER') ? -1 : 0)
                )
                return locationWiseEvents
            } else return []
        },
        getCurrentSelectedEvent() {
            let curr = this.locationWisePatients.find(loc => loc.events.find(evn => evn.eventId === this.currEvent))
            return curr
        }
    }
    
}
</script>

<style lang="scss" scoped>
@import "style.scss";

.location-list {
    text-align: left;
    margin-left: 7px;
    padding: 5px 0 0 7px;
    border-left: 1px solid #ccc;
}
.location-cont {
    font-size: 13px;
    position: relative;
    color: #333;
    span {
        display: inline-block;
    }
}
.location-patients {
    position: absolute;
    right: 15px;
    top: 1px;
    width: 20px;
    padding-left: 0;
    padding-right: 0;
    text-align: end;
    display: flex;
	justify-content: flex-end;
}
.event-expand-icon {
    display: inline-block;
    width: 15px;
    height: 20px;
    line-height: 20px;
    font-size: 10px;
    cursor: pointer;
    text-align: center;
    transition: transform 0.3s ease-in;
}
.event-expand-icon.open {
    transform: rotate(90deg);
}
</style>
